import React from 'react';
import TenderCollection from '../Tenders/TenderCollection';
export default function TenderArchiveList() { return <TenderCollection archive />; }
